export default __webpack_public_path__ + "static/media/xblocDefault.45810c2c.png";